var ruleObj = {
    "总户数": "总户数；一期X户，二期X户；已购买户数及户数类型数量（住宅、商业、公寓、）一期：如果地下室相连只填一个表（一期二期地下室相连只写一个）",
    "总车位数": "项目车位总数X已售X：（负一层个数：标准、子母、微型、人防；负二层个数：标准、子母、微型、人防；<br/>标准车位销售价格【入场前标准车位价格】；<br/>车位空置率，若有特殊情况需写备注）<br/>未售X：（写清楚：剩余产权车位、人防车位、机械车位、余其他车位）总空置率、目前标准车位所售价格",
    "工抵车位": "按实际情况写清楚数量、底价、所在区域描述若有特殊情况请写好备注",
    "户车比": "X：Y（包含所有车位形式）填写清楚含人防车位X；<br/>含小区地面车位X；",
    "第二个车位购买户数": "写清楚第二个车位购买户数",
    "未售车位归属方": "新增多个归属方同时属于多方所有，需要写清楚备注<br/>例：开发商(备注：成都双流富豪实业有限责任公司）需要在备注写上具体名字",
    "过往销售价格及政策": "新增多个过往销售价格最近几次的信息（时间内对应的价格、对应的销售数量）<br/> 例：营销日期：2022-12-1营销到期时间：2023-1-31营销团队：开发商/时代蜂族/XX公司本批次销售价格：(车位数量：19售价：30000)",
    "甲方销售情况及团队概述": "最近一次销售情况说明（团队人数、销售政策、备注）<br/>例如：甲方有一个销售，赠送管理费同事委托物业售卖，一个提成300元，开发商地下室做了整改，拉了100把锁）",
    "是否做过分期及分期银行": "若有做过，写清楚银行名称 <br/>例：是，浙商银行",
    "户型面积及占比": "占比自动生成，增加公寓类型（套四后）根据小区实际情况进行填写（最小面积-最大面积），占比自动生成<br/> 例：35-106套一户数面积：35m²~49m²占比%备注：共725户，商铺52户，公寓210户套二户数面积：69m²~80m²占比%备注：451套三户数面积：80m²~106m²占比%备注：12户",
    "小区类型": "菜单选择：刚需（100㎡以下的户数占80%及以上的）、偏刚需（100㎡以下的户数在50%-80%的）改善（100㎡以上的户数占80%的）、公寓、回迁",
    "返迁安置户数": "0（只能填数量），价格备注，在哪些楼栋",
    "交房日期": "根据小区期数进行填写1期：2015-07-22、2期：2018-4-1、3期：2022-12-1",
    "不含管理费车位租金": "增加备注描述：若按排量则必须按排量填写<br/>例：排放2.0以下租金<br/>排放2.0以上最近<br/>排放子母车位租金X",
    "车位与楼栋关系分析": "需要填写清楚：楼栋数（无法直达地下室）、未售车位数（无法直达地下室）地面车位紧邻楼栋数；<br/>可以直达负一，不能到负二的楼栋；",
    "商业车位与住宅车位是否分区管理": "选是/否；备注：例：分开的，商业车位有单独门禁系统，单独收费标准；",
    "临停数量": "写清楚临停数量及位置【地下及地上临停数量，目前只能写数字】 <br/>例如：临停30个，地上临停10个，地下临停20个；在2号门进门处",
    "临停费用": "临停费用，精细到小时，一天<br/>例：2小时内5元，2小时以上每小时加2元，每24小时48封顶",
    "项目纠纷及特殊情况": "写清楚纠纷的原因，及纠纷情况描述；<br/>例如：开发商正在和前一批次统一售卖业主打官司。车位有漏水，开发商不处理",
    "入住人群分析": "填写业主的人群类型分析； <br/> 例：小区业主80%都是附近汽车厂工人，10%附近农民，10%养老人群",
    "租房率": "（拓展以物业数据为准填写，销售以实际数据）",
    "车位空置数": "车位空置数=未售车位-临停车位-长租车位 <br/>车位空置率=（未售车位-临停车位-长租车位）/总车位",
    "购房群体投资比例": "例：比例：30% <br/>备注：公寓210户",
    "换房意愿比例": "比例：30%备注：户型小",
    "车位租金缴纳方式": "月付（以物业数据为准）备注：开发商收租，但无月租",
    "外面停车位距离小区距离(米)": "10（大概距离±100米）",
    "业委会是否配合": "下拉菜单是/否；加备注：不配合的原因描述",
    "物管是否配合": "下拉菜单是/否，加备注：不配合的原因描述",
    "车位空置费是否结算给物业": "否的，要填写备注（协商减免或其它情况）",
    "是否提前安排车辆霸库及外围打围": "菜单下拉，选是的话，要填写负责人名称",
    "开发商及物业水准": "备注需要描述：口碑，形象，客户满意度"
}
export const projectRuleObj = {
    getRuleInfo(key) {
        return ruleObj[key]
    }
}


// WEBPACK FOOTER //
// ./src/commonjs/projectRule.js